import React, { createContext, useContext, type ReactNode } from "react";
import type { ApplicationLocaleOption } from "./i18next";

const ApplicationLocaleContext = createContext<ApplicationLocaleOption[]>([]);

export const ApplicationLocaleProvider = ({
    options,
    children,
}: {
    options: ApplicationLocaleOption[];
    children: ReactNode;
}) => (
    <ApplicationLocaleContext.Provider value={options}>
        {children}
    </ApplicationLocaleContext.Provider>
);

export const useApplicationLocaleOptions = () =>
    useContext(ApplicationLocaleContext);
